import { ICommonList } from '@/interfaces/common.interface';
import React, { useState } from 'react';

interface FilterButtonsProps {
  filters?: ICommonList[];
  onChange?: (filter: string) => void;
}

const FilterButtons: React.FC<FilterButtonsProps> = ({
  filters = [],
  onChange,
}) => {
  const [activeFilter, setActiveFilter] = useState<string>(
    filters[0]?.value || '',
  );

  const handleClick = (filter: string) => {
    setActiveFilter(filter);
    if (onChange) onChange(filter);
  };

  return (
    <div
      style={{ scrollbarWidth: 'thin' }}
      className="flex gap-1 sm:gap-3 flex-wrap"
    >
      {filters.map((filter) => (
        <button
          type="button"
          key={filter.value}
          onClick={() => handleClick(filter.value)}
          className={`min-w-fit text-nowrap whitespace-nowrap py-2 sm:py-3 px-3 rounded-lg sm:rounded-2xl border text-sm sm:text-base
            ${
              activeFilter === filter.value
                ? 'text-primary border-primary'
                : 'text-gray-500 border border-transparent'
            }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default FilterButtons;
